import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';
import {  MarkupTable, Header, RowItem } from '../builder/TabledItemsList.js';
import Module from '../ui_items/Module.js';
import ModuleHeader from '../ui_items/ModuleHeader.js';
import Select from '../builder/Select.js';
import SectionSubtitle from '../builder/SectionSubtitle.js';
import TextArea from '../builder/TextArea.js';
import Model from '../builder/Model';
import ButtonCollection from '../builder/ButtonCollection.js';
import SaveButton from '../builder/SaveButton.js';
import Tooltip from '../builder/Tooltip.js';
import { AlertMessage } from '../builder/Message.js';

const saveHeaders = (promotion,cb) => {
    const fields = ['csp_level','csp_allowed_domains','csp_allowed_widget_domains']
    const data = {
        id: promotion.id,
    }
    fields.map(field=>{
        if (promotion[field] == undefined) return;
        data[field] = promotion[field];
    })

    $.post(`/promotions/save/${promotion.id}`, data, (r) => {
        cb();
    });
}


const SecurityCenterHeaders = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
    if (!window.features.includes('headers_security')) return null;
	return (
		<Module>
			<ModuleHeader
				subtitle={i18n("Enhance the protection of your promotion with preconfigured HTTP security headers designed to offer a high level of security without affecting the user experience.")}
				autotranslate={false}
			>{`${i18n(" Security headers")}`}</ModuleHeader>

            <MarkupTable 
                column_defs={{
                    gridTemplateColumns:'1fr 1fr 1fr',
                }}
            >
                <Header>Header</Header>
                <Header>Applied Value</Header>
                <Header>Description</Header>

                <RowItem>Strict-Transport-Security</RowItem>
                <RowItem>max-age=63072000; includeSubDomains; preload</RowItem>
                <RowItem>Enforces secure HTTPS connections</RowItem>

                <RowItem>X-Content-Type-Options</RowItem>
                <RowItem>nosniff</RowItem>
                <RowItem>Prevents the bRowItemser from interpreting incorrect content types.</RowItem>
               
                <RowItem>Permissions-Policy</RowItem>
                <RowItem>accelerometer=(), camera=(), fullscreen=(), geolocation=(), gyroscope=(), magnetometer=(), microphone=(), payment=(), sync-xhr=(), usb=()</RowItem>
                <RowItem>Restricts access to sensitive bRowItemser features.</RowItem>
               
                <RowItem>Referrer-Policy</RowItem>
                <RowItem>strict-origin-when-cross-origin</RowItem>
                <RowItem>Protects privacy by avoiding sending full URLs as the referer to other domains.</RowItem>
         
            </MarkupTable>

            <ModuleHeader
				subtitle={i18n("Control which domains are allowed to load content such as scripts, images, styles, or external connections in your promotion. This policy helps prevent attacks like malicious code injection (XSS).")}
				autotranslate={false}
			    >{`${i18n("Content-Security-Policy (CSP) configuration")}`}
            </ModuleHeader>

            <SectionSubtitle>
                Option 1: Basic configuration (recommended for most promotions)
                Allows content from any origin to ensure compatibility with external scripts, integrations, and custom widgets.
            </SectionSubtitle>

            <SectionSubtitle>
                Option 2: Advanced configuration (define allowed domains)
                Customize your security policy by specifying trusted domains for loaded content and for widget integration.
            </SectionSubtitle>
            
            {props.promotion?.csp_level != 'advanced' && (    
            <AlertMessage
                title="Select Advanced only if you are a security engineer or you fully understand how CSP works"
            />
            )}
            
            <Model model={props.promotion} change={props.changePromotion}>
                <Select 
                    name="csp_level"
                    value={props.promotion.csp_level} 
                    change={props.changePromotion}
                    values={[
                    {k:'basic',v:"Basic"},
                    {k:'advanced',v:"Advanced"},
                ]}>Security Level</Select>
            </Model>
            {props.promotion?.csp_level == 'advanced' && (
                <div>
                     <SectionSubtitle>
                        <strong>Allowed content domains</strong>
                        <p>
                        Enter the domains that are allowed to load resources such as scripts, styles, images, fonts, or external connections. Example: https://mydomain.com If you have multiple domains, enter one per line.
                        </p>
                        <Model model={props.promotion} change={props.changePromotion}>
                        <TextArea name="csp_allowed_domains" />
                        </Model>
                    </SectionSubtitle>

                    <SectionSubtitle>
                        <strong>Allowed widget embedding domains (iframe)</strong>
                        <p>
                        Specify the domains that are allowed to embed the promotion inside an iframe (for example, on the client’s website). Example: https://mydomain.com If you have multiple domains, enter one per line.
                        </p>
                        <Model model={props.promotion} change={props.changePromotion}>
                        <TextArea name="csp_allowed_widget_domains" />
                        </Model>
                    </SectionSubtitle>
                </div>
            )}

            <ButtonCollection>
                <SaveButton onClick={(e,cb)=>saveHeaders(props.promotion,cb)}>Save</SaveButton>
            </ButtonCollection>
			
		</Module>
	);
}

export default injectIntl(SecurityCenterHeaders);